import { render, staticRenderFns } from "./publicIcon.vue?vue&type=template&id=8e2f18d2&scoped=true&"
import script from "./publicIcon.vue?vue&type=script&lang=js&"
export * from "./publicIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2f18d2",
  null
  
)

export default component.exports